import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';

import PrivateRoute from '../Auth/PrivateRoute';
import AdminRoute from '../Auth/AdminRoute';
import Protected from '../Auth/Protected';

import TeamViewContainer from '../../containers/Team/TeamViewContainer';
import TeamEditContainer from '../../containers/Team/TeamEditContainer';
import DraftViewContainer from '../../containers/Draft/DraftViewContainer';
import DraftEditContainer from '../../containers/Draft/DraftEditContainer';
import LoginContainer from '../../containers/Auth/LoginContainer';


class Routes extends Component {

    render() {
        return (
            <Switch>
                <Route exact path="/" component={DraftViewContainer} />
                <Route exact path="/login" component={LoginContainer} />
                <Route exact path="/teams" component={TeamViewContainer} />
                <AdminRoute exact path="/create-draft" component={DraftEditContainer} isAuthenticated={this.props.user.isAuthenticated} isAdmin={this.props.user.isAdmin}/>
                <AdminRoute exact path="/create-draft/:id" component={DraftEditContainer} isAuthenticated={this.props.user.isAuthenticated} isAdmin={this.props.user.isAdmin} />
                <AdminRoute exact path="/create-team" component={TeamEditContainer} isAuthenticated={this.props.user.isAuthenticated} isAdmin={this.props.user.isAdmin} />
                <AdminRoute exact path="/create-team/:id" component={TeamEditContainer} isAuthenticated={this.props.user.isAuthenticated} isAdmin={this.props.user.isAdmin} />
                <PrivateRoute exact path='/protected' component={Protected} isAuthenticated={this.props.user.isAuthenticated} />
            </Switch>
        );
    }
}

export default Routes;


// WEBPACK FOOTER //
// ./src/components/App/Routes.js